import { createAction as e } from "@reduxjs/toolkit";
const o = "knowledge/smartConversationResponse", n = {
  smartConversationResponseReceived: e(
    `${o}/received`
  ),
  smartConversationResponseRequested: e(`${o}/requested`),
  smartConversationResponseError: e(
    `${o}/error`
  ),
  smartConversationResponseFinally: e(`${o}/finally`)
};
export {
  n as knowledgeActions
};
//# sourceMappingURL=knowledge.actions.js.map
